module.exports = __webpack_public_path__ + "51b3cc13ef57780b29afe4c7e4495dc8.png";